// Canonical brand mascot (user-supplied). Do NOT replace or regenerate.
export function DonkeyMascot({ className = "", size = 220, alt = "The Honest Donkey" }) {
  return (
    <img
      src="/donkey-hero.png"
      alt={alt}
      style={{ height: size, width: "auto", objectFit: "contain" }}
      className={className}
      data-testid="donkey-mascot"
    />
  );
}

// Circular face crop of the canonical donkey, used as a contextual guide avatar.
export function DonkeyAvatar({ size = 48, className = "" }) {
  return (
    <span
      style={{ width: size, height: size }}
      className={`relative inline-flex shrink-0 rounded-full overflow-hidden bg-[#111111] ring-1 ring-donkey-orange/40 ${className}`}
      aria-hidden="true"
    >
      <img
        src="/donkey-hero.png"
        alt=""
        className="absolute max-w-none pointer-events-none select-none"
        style={{ width: size * 3, height: "auto", left: -size * 1.38, top: -size * 1.42 }}
      />
    </span>
  );
}

// Restrained mascot-led guidance panel. Use for "why I'm asking", warnings,
// empty states, analysis progress and verdict commentary.
export function DonkeyGuide({ children, title, tone = "neutral", className = "", size = 48 }) {
  const toneRing = {
    neutral: "border-donkey-line",
    caution: "border-donkey-amber/40",
    warning: "border-donkey-red/40",
    positive: "border-donkey-green/40",
  }[tone] || "border-donkey-line";
  return (
    <div
      className={`relative flex items-start gap-4 p-5 sm:p-6 rounded-2xl bg-donkey-bg border ${toneRing} overflow-hidden ${className}`}
      data-testid="donkey-guide"
    >
      <span className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-donkey-orange to-transparent" aria-hidden />
      <DonkeyAvatar size={size} />
      <div className="min-w-0">
        {title && <p className="font-heading font-semibold text-donkey-warm text-sm mb-1">{title}</p>}
        <div className="text-sm text-donkey-warm/80 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

export default DonkeyMascot;
